import React, { Fragment } from 'react';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';

const RequirementsModal = ({ open, closeModal, details }) => (
  <Modal open={open}>
    <div className="signup__requirements--container">
      {details ? (
        <Fragment>
          <img className="signup__requirements--image" src={details.image} alt="skyline" />
          <div className="signup__requirements--details" onClick={closeModal}>
            To drive in {details.fullName}, you must meet these minimum requirements:
          </div>
          <ol className="signup__requirements--list">
            {details.requirements.map(requirement => <li> {requirement} </li>)}
          </ol>
        </Fragment>
      ) : null}
      <div className="signup__requirements--button">
        <Button fullWidth label="Okay" onClick={() => closeModal()} />
      </div>
    </div>
  </Modal>
);

export default RequirementsModal;



// WEBPACK FOOTER //
// ./src/components/SignUp/RequirementsModal.js